import type { PrintComExcludeRules } from '@/lib/printcom/printing-method-selection';

/** Evaluate supplier combinations using the configurator's resolved defaults. */
export function isExcludedByConfiguredOptionRules(
  excludes: PrintComExcludeRules | undefined,
  resolveProperty: (property: string) => { value: unknown; hidden?: boolean },
): boolean {
  return (excludes || []).some((rule) => {
    if (!Array.isArray(rule) || rule.length < 2) return false;
    return rule.every((condition) => {
      const property = condition?.property;
      const values = (condition?.options || []).map(String);
      if (!property || values.length === 0) return false;
      const { value, hidden } = resolveProperty(property);
      // Preserve the configurator's conservative handling of hidden defaults.
      if (hidden && (value === undefined || value === '')) return true;
      return value !== undefined && value !== '' && values.includes(String(value));
    });
  });
}
